import React from "react";
import Typography from "@material-ui/core/Typography";
import BarChartIcon from "@material-ui/icons/BarChart";
import { analyseTheme } from "../../../analyseTheme";
import { ANALYSE_INCIDENTS_SUPPORTED_LABELING_TYPE } from "store/analyse-store/analyseStore";

const LABELING_TYPE_LABELS: Record<string, string> = {
  VIDEO: "VIDEO",
  RECTANGLE_BOXING: "RECTANGLE BOXING",
  PLATE: "PLATE",
  PLATE_TEXT: "PLATE TEXT",
  CLASSIF: "CLASSIFICATION",
  SEGMENTATION: "SEGMENTATION",
};

const formatLabelingType = (labelingType?: string | null) => {
  if (!labelingType) return "inconnu";
  return LABELING_TYPE_LABELS[labelingType] || labelingType;
};

type Props = {
  labelingType?: string | null;
};

const IncidentsUnsupportedProjectMessage = ({ labelingType }: Props) => (
  <div
    style={{
      flex: 1,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 12,
      color: analyseTheme.textSecondary,
      minHeight: 260,
      padding: "0 24px",
      textAlign: "center",
    }}
  >
    <BarChartIcon
      style={{
        fontSize: 128,
        opacity: 0.45,
        color: analyseTheme.secondaryLight,
      }}
    />
    <Typography
      variant="body1"
      style={{ fontWeight: 600, color: analyseTheme.textPrimary }}
    >
      Type de projet n&apos;est pas encore pris en charge
    </Typography>
    <Typography variant="body2" color="textSecondary" >
      Analyse disponible uniquement pour les projets de
      type {ANALYSE_INCIDENTS_SUPPORTED_LABELING_TYPE}. Le projet selectionné est
      de type {formatLabelingType(labelingType)}.
    </Typography>
  </div>
);

export default IncidentsUnsupportedProjectMessage;
